import React from 'react';
import Button from './Button';
import './Messages.css';

const Messages = ({ text, state, onClickHandler }) => (
    <div className={`messages__container ${state}`} id="messages__container">
        <div className="message" id="message">
            <div className="message__text" id="message__text">{text}</div>
            <Button text="OK" type="button-message" onClickHandler={onClickHandler} />
        </div>
    </div>
);

export default Messages;
